import { Role } from '@/Enums/Users/Role.enum';
import { IRequestWhitelabel } from '@/Interfaces/Whitelabels/Whitelabel.interface';
import { IWhitelabelFormData } from '@/Interfaces/Whitelabels/WhitelabelFormData.interface';
import { DEFAULT_WHITELABEL } from '@/constants/whitelabels';
import { isSuperAdminRole } from '../roles';

export function getDirtyValues<
  DirtyFields extends Record<string, unknown>,
  Values extends Record<keyof DirtyFields, unknown>,
>(dirtyFields: DirtyFields, values: Values): Partial<typeof values> {
  const dirtyValues = Object.keys(dirtyFields).reduce((prev, key) => {
    if (!dirtyFields[key]) return prev;

    return {
      ...prev,
      [key]:
        typeof dirtyFields[key] === 'object'
          ? getDirtyValues(dirtyFields[key] as DirtyFields, values[key] as Values)
          : values[key],
    };
  }, {});

  return dirtyValues;
}

export const getWhitelabelRequestPayload = (
  formData: Partial<IWhitelabelFormData>,
  createPayload?: boolean,
): Partial<IRequestWhitelabel> => {
  const sidebarLogoImg = createPayload ? formData.sidebarLogo || formData.mainLogo : formData.sidebarLogo;
  return {
    name: formData.name,
    loginBg: formData.loginBg,
    buttonBg: formData.buttonBg,
    loginTextDark: formData.loginTextDark,
    sidebarBg: formData.sidebarBg,
    sidebarTextColor: formData.sidebarTextColor,
    mainLogoImg: formData.mainLogo as File,
    sidebarLogoImg: sidebarLogoImg as File,
    faviconImg: formData.favicon as File,
    domain: formData.domain,
    domainExternal: formData.domainExternal,
    parentId: formData.organization?.value,
    requiresCampaignApproval: formData.requiresCampaignApproval,
    sendEmailNotification: formData.sendEmailNotification,
  };
};

export const validateImage = (file: File, controlName: string) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = event => {
      try {
        const img = new Image();
        img.onload = () => {
          return resolve(void 0);
        };
        img.onerror = () => {
          return reject({ message: 'Image load failed.', name: controlName });
        };
        img.src = event.target!.result as string;
      } catch {
        return reject({ message: 'Unhandled validation error.', name: controlName });
      }
    };

    reader.readAsDataURL(file);
  });
};

export const getDefaultNewWhitelabel = (meRole: Role, meWhitelabel: number): IWhitelabelFormData => {
  if (isSuperAdminRole(meRole)) {
    return DEFAULT_WHITELABEL;
  }
  return { ...DEFAULT_WHITELABEL, organization: { label: '', value: meWhitelabel } };
};
